import { Base } from 'components/template';
import { ProgressBar } from 'components/molecules';
import logo from '_utilities/images/logo.png';
import { Link } from 'react-router-dom';

const prefix = "v-account-created";

const AccountCreated = () => {
  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-5/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-1">
          <img src={logo} alt="nbsk-logo" className="w-[55%] mx-auto mb-5"/>
          <ProgressBar max={1} progress={1} />
          <p className="text-center text-3xl font-bold mx-auto mt-5">Esta empresa ya tiene</p>
          <p className="text-center text-3xl font-bold mx-auto mb-8">una cuenta creada</p>
          <p className="text-center text-xl mx-auto mb-5">Ponte en contacto con soporte para gestionar tu acceso con el administrador de la cuenta</p>
          <p className="text-center text-xl mx-auto mb-8">
            <Link to="mailto:soporte@nubesk.com.mx" className='underline font-bold'>soporte@nubesk.com.mx</Link>
          </p>

          <p className="text-center text-xl mx-auto"><Link to="/" className='underline font-bold'>Regresar al inicio</Link></p>
        </div>
      </div>
    </Base>
  );
};

export default AccountCreated;

